import React from 'react';
import { LightBox } from '@lion-design/core';
import styles from './styles.module.scss';
import { I_CallJson } from '@Redux/detail/Group/interfaces';

interface I_Props {
    origin: string;
    open: boolean;
    ToggleLightBox: () => void;
    callJson: I_CallJson;
    GroupInfo?: any;
}

function ContactStaff({ origin, open, callJson, GroupInfo, ToggleLightBox }: I_Props) {
    return (
        <LightBox
            open={origin === 'search' || GroupInfo?.GroupID ? open : true}
            ToggleLightBox={
                origin === 'search' || GroupInfo?.GroupID
                    ? ToggleLightBox
                    : () => (location.href = `//${window.location.host}`)
            }
        >
            <h4 className={styles.title}>
                {origin === 'search' || GroupInfo?.TravelType !== 0
                    ? '訂購電話'
                    : '此地區已無產品在架上，若有需求請洽服務人員'}
            </h4>
            <div className={styles.contactBlock}>
                <h4>{callJson?.BuName}</h4>
                <ul className={styles.foreign}>
                    {Array.isArray(callJson.Data) &&
                        callJson.Data.map((item, index) => {
                            return (
                                <li key={index}>
                                    {item.Staff} {item.Phone}
                                </li>
                            );
                        })}
                </ul>
            </div>
        </LightBox>
    );
}

export default ContactStaff;
